import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { CardContent, useTheme } from '@mui/material';
import AnalyticsPieVisits from 'src/sections/overview/analytics/analaticspiechart';

// Assuming pieChartData is defined as shown above

const ForecastPieChart: React.FC = () => {
  const theme = useTheme();
  return(
  <Card>
    <CardContent>
      <Typography
        variant="h6"
        gutterBottom
        style={{
          display: 'flex',
          marginBottom: '0px',
          fontSize: '1.2rem',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        Cost Pool Spend
        {/* <InfoIcon color="action" style={{ paddingLeft: '5px', color: '#4040ab' }} /> */}
      </Typography>
      <Typography color="grey" style={{ display: 'flex', fontWeight: '300', fontSize: ' 0.7rem' }}>
        This month (March 2024)
      </Typography>

      <AnalyticsPieVisits
        chart={{
          colors: [
            theme.palette.secondary.main,
            theme.palette.info.darker,
            theme.palette.info.main,
            theme.palette.primary.light,
          ],
          series: [
            { label: 'Archive Project Cost', value: 3 },
            { label: 'Archive Licensing Cost', value: 2 },
            { label: 'Application Costs', value: 36 },
            { label: 'Baseline Application Budget ', value: 59 },
          ],
        }}
      />
    </CardContent>
  </Card>
);
      }
export default ForecastPieChart;